export const GW_SERVICES_PREFIXES = {
  AUTH: 'auth',
  GPB_ACQUIRING: 'gpb/acquiring',
  GPB_APPROVE: 'gpb/approve',
  DISPATCHER: 'dispatcher', //TODO: устарело
  REQ: 'req',
  INTERNAL: 'lkzh',
  C300: 'c300/api/v4',
  FILES:
    window.origin.includes('https://lk.operation-gs.ru') ||
    window.origin.includes('https://lk2.eis24.me') ||
    window.origin.includes('https://xn----7sbdqbfldlsq5dd8p.xn--p1ai') ||
    window.origin.includes('https://lk.seatown.ru')
      ? 'https://files.eis24.me'
      : 'https://test-files.eis24.me',
} as const;
